export const STEPPER_STATE_KEY_LS = "Stepper_State"